import { Button, Flex, Icon, useMediaQuery } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";

import { useIcons } from "../../hooks/useIcons";
import { minWidth800BP } from "../../constants";
import { VivoLogo } from "../VivoLogo";

import { NavigationBarWithIcon } from "./style";

interface IProps {
	showBar?: boolean;
	bgColor?: string;
	backButtonColor?: string;
	isPositionFixed?: boolean;
	children?: React.ReactNode;
	isFFVivoPayLogo?: boolean;
	onBack?(): undefined | void;
}

export const NavigationBar: React.FC<IProps> = observer(({ onBack, children, showBar = true, bgColor, backButtonColor, isPositionFixed, isFFVivoPayLogo = true }) => {
	const [isDesktop] = useMediaQuery(minWidth800BP);
	const { leftChevron, vivoIcon, moneyVivo } = useIcons();

	return (
		<NavigationBarWithIcon isFixed={isPositionFixed} bgColor={bgColor} isDesktop={isDesktop}>
			{showBar && (
				<>
					<Button disabled={onBack ? false : true} cursor={onBack ? "pointer" : "default"} variant="ghost" onClick={onBack} maxWidth={50} sx={{ WebkitTapHighlightColor: "transparent" }}>
						<Icon display={onBack ? "inline-flex" : "none"} margin="right" fill={backButtonColor ? backButtonColor : "gray.600"} as={leftChevron} w="24px" h="24px" />
					</Button>
					<Flex bg={bgColor} id="top-icons" ml={-59} gap="5px">
						{isFFVivoPayLogo ?
							<VivoLogo variant={bgColor ? "white" : "purple"} w={{ base: "70px", sm: "70px", lg: "85px" }} h={{ base: "23px", sm: "23px", lg: "28px" }} />
							:
							<>
								<Icon fill={bgColor ? "white" : "primary"} as={vivoIcon} w={{ base: "14px", sm: "14px", lg: "16px" }} h={{ base: "19px", sm: "19px", lg: "23px" }} />
								<Icon fill={bgColor ? "white" : "primary"} as={moneyVivo} w={{ base: "70px", sm: "70px", lg: "90px" }} h={{ base: "23px", sm: "23px", lg: "28px" }} />
							</>
						}
					</Flex>
				</>
			)}
			{children}
		</NavigationBarWithIcon>
	);
});
